import { Component } from '@angular/core';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { RouterFacade } from '@cigna/core/router-state';
import { Observable } from 'rxjs';
import { RouteData } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-undeveloped-page',
  templateUrl: './undeveloped-page.component.html',
  styleUrls: ['./undeveloped-page.component.scss'],
})
export class UndevelopedPageComponent {
  routeData$: Observable<RouteData | null>;

  pageTitle = 'Page Not Available Yet for Beta Site';

  constructor(private routerFacade: RouterFacade) {
    this.routeData$ = this.routerFacade.data$ as Observable<RouteData | null>;
  }
}
